export const environment = {
    navigatorBaseUrl: 'NAVIGATOR_BASE_URL'
};
